module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Regular.woff2?203343ee913a903ad2751cfa6a95dcfa";